import React, { useCallback, useEffect, useState } from 'react';
import { Select } from '@components/FormInputs';
import { Section, SettingsSectionBox, SettingsSectionLabel } from '@views/Settings/components';
import styles from './MomentsEmailClient.module.scss';

const options = [
  { value: '', label: 'default browser' },
  { value: 'superhuman', label: 'Superhuman' },
];
const optionsByValue = options.reduce(
  (optsMap, option) => ({ ...optsMap, [option.value]: option }),
  {},
);

export default function MomentsEmailClient() {
  const [value, setValue] = useState(optionsByValue['']);

  useEffect(() => {
    const emailClient = window.localStorage.getItem('email_client');
    setValue(optionsByValue[emailClient || '']);
  }, []);

  const onChange = useCallback((option) => {
    setValue(option);
    window.localStorage.setItem('email_client', option.value);
  }, []);

  return (
    <Section>
      <SettingsSectionLabel>Moments</SettingsSectionLabel>
      <SettingsSectionBox className={styles.container}>
        <div>
          View Moments in
          <Select
            className={styles.select}
            options={options}
            value={value}
            onChange={onChange}
            isInline
            alignMenuRight
          />
        </div>
        <p>
          Not all mail apps support deep linking to a specific message, so Clay will open emails and
          events from Moments in your browser by default.{' '}
          <a
            href="https://library.clay.earth/hc/en-us/articles/12524176258459-How-do-the-email-preference-settings-work-"
            target="_blank"
          >
            Learn more about email settings
          </a>
          .
        </p>
      </SettingsSectionBox>
    </Section>
  );
}
